module.exports = __webpack_public_path__ + "media/fonts/PoppinsLatin-Medium-e6e597634bbbc5faaf3276bd4213dbe3.ttf";